import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

const Container = styled(View)`
  margin-vertical: 10px;
  border-width: 2px;
  border-style: solid;
  border-color: red;
  padding: 6px;
`;

const PATH_MAP = {
  txnLines: 'Transaction line debits and credits'
};

const pathName = path => {
  const name = path[path.length - 1];

  if ('reference' === name) { return 'Invoice #'; }
  return PATH_MAP[name] || name;
};

const MutationErrors = ({ errors }) => {
  if (!errors || 0 === errors.length) { return null; }

  return (
    <Container>
      <Text>There was an error:</Text>
      {errors.map(error => (
        <Text>
          {pathName(error.path)} {error.message}
        </Text>
      ))}
    </Container>
  );
};

export default MutationErrors;
